import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Review from '../components/review';
import '../css/Home.css';
import '../css/Service.css';

const Autoclave = () => {
  const [previewSrc, setPreviewSrc] = useState(null);

  const showPreview = (src) => setPreviewSrc(src);
  const hidePreview = () => setPreviewSrc(null);

  return (
    <div className="service-page">
      {previewSrc && (
        <div
          onClick={hidePreview}
          onMouseLeave={hidePreview}
          role="button"
          tabIndex={0}
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 2000,
            cursor: 'zoom-out'
          }}
        >
          <img src={previewSrc} alt="Preview" style={{ maxWidth: '92%', maxHeight: '92%', boxShadow: '0 6px 30px rgba(0,0,0,0.6)' }} />
        </div>
      )}

      <div className="service-banner">
        <img src="/autoclave.jpeg" alt="Autoclave Banner" className="service-banner-img" onMouseEnter={() => showPreview('/autoclave.jpeg')} onClick={() => showPreview('/autoclave.jpeg')} />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Autoclave & Advanced Waste Processing</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>Our Advanced Waste Processing Technology</h1>
        <p>Clean World combines autoclaving and incineration to deliver safe, compliant, and efficient hazardous waste treatment.</p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>What is an Autoclave?</h2>
          <p className="lead" style={{ textAlign: 'justify' }}>
            An autoclave is a high-pressure steam sterilizer — think of a large, industrial pressure cooker — that uses saturated steam at elevated temperatures (typically 121°C–134°C) and pressure to eliminate bacteria, viruses, and resistant spores.
          </p>

          <h3>The Role of the Autoclave in Our Facility</h3>
          <p style={{ textAlign: 'justify' }}>
            Introducing autoclaving before incineration gives our clients important benefits for handling biomedical and infectious waste streams.
          </p>

          <ol>
            <li>
              <strong>Primary Sterilization and Pathogen Elimination:</strong> The autoclave renders infectious wastes biologically inert, converting them into non-regulated, safe-to-handle material and ensuring safety for staff and the public.
            </li>
            <li>
              <strong>Increased Worker Safety:</strong> Sterilizing waste prior to handling or incineration reduces exposure risks and prevents cross-contamination in downstream processes.
            </li>
            <li>
              <strong>Volume Reduction and Pre-Treatment:</strong> Autoclaves are often integrated with shredding systems to reduce physical volume (sometimes up to ~70%), improving transport and incineration efficiency.
            </li>
            <li>
              <strong>Optimized Combustion and Energy Efficiency:</strong> Pre-treatment can assist in drying moist organic waste, lowering auxiliary fuel needs during incineration and improving combustion.
            </li>
            <li>
              <strong>Regulatory Compliance and Assurance:</strong> Our autoclave step ensures sterilization and de-identification where required by regulation, providing documented compliance and peace of mind.
            </li>
          </ol>

          <h3>The Power of Two: Autoclave & Incineration</h3>
          <p style={{ textAlign: 'justify' }}>
            By combining precise biological destruction via autoclaving with high-temperature incineration, Clean World guarantees thorough, documented, and final disposal of hazardous and infectious wastes.
          </p>

          <h3>Clean World's Commitment</h3>
          <p style={{ textAlign: 'justify' }}>
            We invest in proven technologies and process controls that prioritise public health, staff safety, and environmental protection. When you choose Clean World, your waste is processed using a scientifically proven, multi-layered approach.
          </p>

          <div className="service-cta mt-3">
            <a href="/contact" className="btn btn-primary">Contact Us</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="image-pair" style={{ marginBottom: '1rem' }}>
            <img src="/autoclave.jpeg" alt="Autoclave" style={{ width: '100%', height: '300px', objectFit: 'cover', marginBottom: '0.5rem', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/autoclave.jpeg')} onClick={() => showPreview('/autoclave.jpeg')} />
            <img src="/ash_room.jpeg" alt="Ash Room" style={{ width: '100%', height: '300px', objectFit: 'cover', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/ash_room.jpeg')} onClick={() => showPreview('/ash_room.jpeg')} />
          </div>

          <div className="specialty-card">
            <h3>Why Choose Clean World</h3>
            <ul className="specialty-list">
              <li>Autoclave sterilization and validated cycles</li>
              <li>Documented chain-of-custody and reporting</li>
              <li>Integrated shredding and volume reduction</li>
              <li>Safe, regulated transfer to incineration</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
};

export default Autoclave;
